//@flow
import * as React from "react";
import styled from "react-emotion";
import { theme, mqMin, mqMax } from "../../styles/theme";
import ScrollNotifier from "../ScrollNotifier";

const Screen = styled.section`
  position: relative;
  display: flex;
  flex-wrap: none;
  justify-content: space-around;
  align-items: baseline;
  padding-left: ${theme.space1};
  padding-right: ${theme.space1};
  padding-top: ${theme.space3};
  padding-bottom: ${theme.space4};
  z-index: 2;
  flex-wrap: wrap;
  ${mqMin(theme.desktop)} {
    margin-left: auto;
    margin-right: auto;
    flax-wrap: nowrap;
    max-width: ${theme.maxWidth3};
  }
`;

const Header = styled.div`
  text-align: center;
  line-height: ${theme.lineHeight1};
  font-size: ${theme.super};
  font-family: ${theme.sans.fontFamily};
  font-weight: 700;
  ${mqMax(theme.phone)} {
    font-size: ${theme.big};
  }
`;
const InfoWrap = styled.div`
  margin-bottom: ${theme.space2};
  ${mqMin(theme.tablet)} {
    margin-bottom: 0;
  }
  ${mqMax(theme.phone)} {
    flex-basis: 100%;
    padding-left: ${theme.space1};
    padding-right: ${theme.space1};
  }
`;
const SubHeader = styled.div`
  font-size: ${theme.h2};
  font-family: ${theme.sans.fontFamily};
  font-weight: 400;
  line-height: 1;
  text-align: center;
`;

const HeaderWrap = styled.div`
  align-self: center;
  margin-bottom: ${theme.space3};
  flex-basis: 100%;

  ${mqMin(theme.tablet)} {
    padding-right: ${theme.space2};
  }
`;
const InfoHeader = styled.div`
  font-size: ${theme.h4};
  font-family: ${theme.sans.fontFamily};
  font-weight: ${theme.sans.bold};
`;
const Info = styled.div`
  font-size: ${theme.h4};
  line-height: ${theme.lineHeight3}
  font-family: ${theme.display.fontFamily};
  font-weight: ${theme.display.normal};
`;
const Footer = ({ page, heading = "We Make" }) => {
  return (
    <Screen>
      <ScrollNotifier onEnter="FOOTER" offset="0" />
      <HeaderWrap>
        <Header>PaNDaGOAT</Header>
        <SubHeader>M•E•D•I•A</SubHeader>
      </HeaderWrap>
      <InfoWrap>
        <InfoHeader>Find Us</InfoHeader>
        <Info>
          9 W. Washington St<br />
          Ellicottville, NY 14731<br />
        </Info>
      </InfoWrap>
      <InfoWrap>
        <InfoHeader>Let's Talk</InfoHeader>
        <Info>
          <a href="mailto:info@pandagoatmedia.com">info@pandagoatmedia.com</a>
          <br />
          <a href="tel:(716)699-9816">(716) 699-9816</a>
          <br />
        </Info>
      </InfoWrap>
      <InfoWrap>
        <InfoHeader>Social</InfoHeader>
        <Info>
          <a href="https://www.facebook.com/PandaGoatMedia/?ref=br_rs">
            Facebook
          </a>
          <br />
          <a href="https://www.instagram.com/pandagoatmedia/">Instagram</a>
          <br />
          <a href="https://twitter.com/pandagoatmedia">Twitter</a>
          <br />
        </Info>
      </InfoWrap>
      <InfoWrap>
        <Info>
          <a href="http://abcinema.biz/">ABCinema</a>
          <br />
          Catalyst11 Media & Marketing <br />
          <a href="https://www.facebook.com/EVLSnowedIn/">Design Perks</a>
          <br />
        </Info>
      </InfoWrap>
      <InfoWrap>
        <InfoHeader />
        <Info>
          <a href="https://www.facebook.com/JWoodarekPhotography/">
            Jaimie Woodarek Photography
          </a>
          <br />
          <a href="https://www.robotofthefuture.com/">Robot of the Future</a>
          <br />
        </Info>
      </InfoWrap>
    </Screen>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js